import { render, staticRenderFns } from "./YikudiaobodanTable.vue?vue&type=template&id=475f2b22&scoped=true&"
import script from "./YikudiaobodanTable.vue?vue&type=script&lang=js&"
export * from "./YikudiaobodanTable.vue?vue&type=script&lang=js&"
import style1 from "./YikudiaobodanTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f2b22",
  null
  
)

export default component.exports